import React, { useState, useRef, useEffect } from 'react';
import logo_ventagix from '../../imgs/logo_komity_small.png';
import { usePlan } from '../context/PlanContext';
import ModalCambiarPassword from '../Auth/ModalCambiarPassword';
import ModalPlanes from '../Auth/ModalPlanes';
import './Menu.css';
// 🚩 Add-on Pedidos QR: aviso de mesas en el header, para que el pedido por QR
// y el "pidieron la cuenta" se noten desde cualquier pantalla.
import useAlertasMesas from '../Pedidos/useAlertasMesas';

function Menu({ usuario, cierreSesion, onCambiarPDV }) {
    const [dropdownAbierto, setDropdownAbierto] = useState(false);
    const [modalPasswordAbierto, setModalPasswordAbierto] = useState(false);
    const [modalPlanesAbierto, setModalPlanesAbierto] = useState(false);
    const dropdownRef = useRef(null);

    const rolNormalizado = (usuario && usuario.rol) ? usuario.rol.toLowerCase() : '';
    const esAdmin = ['admin', 'administrador'].includes(rolNormalizado);
    const esGarzon = ['garzon', 'garzón'].includes(rolNormalizado);
    const esOperador = rolNormalizado === 'operador';

    const { plan, tienePOS, tieneMesas, tienePedidosWeb } = usePlan();

    // Solo consulta si el usuario ve mesas. Si el negocio no tiene el add-on el
    // backend devuelve las señales apagadas, asi que los contadores quedan en 0.
    const puedeVerMesas = (esAdmin || esGarzon || esOperador) && tieneMesas;
    const { pedidosNuevos, cuentasPedidas } = useAlertasMesas(puedeVerMesas);

    const NOMBRES_PLAN = {
        MENU_QR: 'Plan Pedidos Web',
        POS: 'Plan POS Take Away',
        RESTAURANTE: 'Plan Restaurante',
    };
    const nombrePlan = NOMBRES_PLAN[plan] || '';


    const isActivo = (ruta) => window.location.pathname.includes(ruta) ? 'activo' : '';

    function Salir(e) {
        e.preventDefault();
        setDropdownAbierto(false);
        if (window.confirm('¿Estás seguro que deseas cerrar sesión?')) cierreSesion();
    }

    // Cerrar dropdown al hacer click fuera
    useEffect(() => {
        function handleClickFuera(e) {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownAbierto(false);
            }
        }
        if (dropdownAbierto) document.addEventListener('mousedown', handleClickFuera);
        return () => document.removeEventListener('mousedown', handleClickFuera);
    }, [dropdownAbierto]);

    const inicial = (usuario && usuario.nombre) ? usuario.nombre.charAt(0).toUpperCase() : 'U';
    const nombreUsuario = (usuario && usuario.nombre) ? usuario.nombre : 'Usuario';
    const rolUsuario = (usuario && usuario.rol) ? usuario.rol : 'Staff';

    return (
        <header className="komity-header-fudo">

            {/* IZQUIERDA: LOGO */}
            <div className="header-logo">
                <img src={logo_ventagix} alt="Komity Logo" />
            </div>

            {/* CENTRO: NAVEGACIÓN PRINCIPAL */}
            <nav className="header-nav">

                {(esAdmin || esOperador) && (
                    <a href="/home/" className={`header-link ${isActivo('/home')}`}>
                        <i className="bi bi-house-door"></i> <span>Inicio</span>
                    </a>
                )}

                {(esAdmin || esGarzon || esOperador) && tienePOS && (
                    <a href="/ventas/tpv/" className={`header-link ${isActivo('/ventas')}`}>
                        <i className="bi bi-shop"></i> <span>Vender</span>
                    </a>
                )}

                {(esAdmin || esGarzon || esOperador) && tieneMesas && (
                    <a href="/mesas/" className={`header-link ${isActivo('/mesas')}`} style={{ position: 'relative' }}>
                        <i className="fas fa-table"></i> <span>Mesas</span>
                        {/* 🚩 Naranjo manda sobre amarillo: si piden la cuenta hay
                            alguien esperando de pie, es lo mas urgente. El titulo
                            dice cual es cual para el que no distinga los colores. */}
                        {(pedidosNuevos > 0 || cuentasPedidas > 0) && (
                            <span
                                className="alerta-mesas"
                                title={[
                                    pedidosNuevos > 0 ? `${pedidosNuevos} mesa${pedidosNuevos !== 1 ? 's' : ''} con pedido nuevo por QR` : null,
                                    cuentasPedidas > 0 ? `${cuentasPedidas} mesa${cuentasPedidas !== 1 ? 's' : ''} pidiendo la cuenta` : null
                                ].filter(Boolean).join(' · ')}
                                style={{ backgroundColor: cuentasPedidas > 0 ? '#fd7e14' : '#ffc107', color: cuentasPedidas > 0 ? '#fff' : '#000' }}
                            >
                                {pedidosNuevos + cuentasPedidas}
                            </span>
                        )}
                    </a>
                )}

                {(esAdmin || esGarzon || esOperador) && (tienePOS || tienePedidosWeb) && (
                    <a href="/pedidos/" className={`header-link ${isActivo('/pedidos')}`}>
                        <i className="bi-card-list"></i> <span>Pedidos</span>
                    </a>
                )}

                {esAdmin && (
                    <a href="/fidelizacion/clientes/" className={`header-link ${isActivo('/fidelizacion')}`}>
                        <i className="bi bi-people"></i> <span>Clientes</span>
                    </a>
                )}

                {esAdmin && tienePOS && (
                    <a href="/admin/inventario/stock" className={`header-link ${isActivo('/inventario')}`}>
                        <i className="bi bi-boxes"></i> <span>Inventario</span>
                    </a>
                )}

                {esAdmin && (
                    <a href="/productos/home/" className={`header-link ${isActivo('/productos')}`}>
                        <i className="bi bi-cup-hot"></i> <span>Menú</span>
                    </a>
                )}

                {esAdmin && plan !== 'MENU_QR' && (
                    <a href="/configuracion/tienda/" className={`header-link ${isActivo('/configuracion/tienda')}`}>
                        <i className="bi bi-qr-code"></i> <span>Carta QR</span>
                    </a>
                )}

                {esAdmin && tienePedidosWeb && (
                    <a href="/configuracion/pedidos-web/" className={`header-link ${isActivo('/configuracion/pedidos-web')}`}>
                        <i className="bi bi-shop"></i> <span>Tienda</span>
                    </a>
                )}

                {esAdmin && tienePOS && (
                    <a href="/reportes/home/" className={`header-link ${isActivo('/reportes')}`}>
                        <i className="bi bi-graph-up"></i> <span>Reportes</span>
                    </a>
                )}

                {esAdmin && (
                    <a href="/configuracion/home/" className={`header-link ${isActivo('/configuracion')}`}>
                        <i className="bi bi-gear"></i> <span>Ajustes</span>
                    </a>
                )}
            </nav>

            {/* DERECHA: AVATAR */}
            <div className="header-actions">
                <div className="user-menu-wrapper" ref={dropdownRef}>
                    <button
                        className={`header-avatar ${dropdownAbierto ? 'activo' : ''}`}
                        onClick={() => setDropdownAbierto(v => !v)}
                        title={nombreUsuario}
                        aria-expanded={dropdownAbierto}
                    >
                        {inicial}
                    </button>

                    {dropdownAbierto && (
                        <div className="user-dropdown">
                            {/* Cabecera: nombre + rol */}
                            <div className="user-dropdown-header">
                                <div className="user-dropdown-avatar">{inicial}</div>
                                <div>
                                    <div className="user-dropdown-nombre">{nombreUsuario}</div>
                                    <div className="user-dropdown-rol">{rolUsuario}</div>
                                </div>
                            </div>

                            {/* Plan actual */}
                            {nombrePlan && (
                                <div className="user-dropdown-plan">
                                    <span className="plan-badge">{nombrePlan}</span>
                                    <button
                                        className="plan-upgrade-link"
                                        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', textAlign: 'left' }}
                                        onClick={() => { setDropdownAbierto(false); setModalPlanesAbierto(true); }}
                                    >
                                        Ver otros planes <i className="bi bi-arrow-right"></i>
                                    </button>
                                </div>
                            )}

                            <div className="user-dropdown-divider" />

                            {/* Punto de Venta activo */}
                            {onCambiarPDV && (
                                <button
                                    className="user-dropdown-item"
                                    onClick={() => { setDropdownAbierto(false); onCambiarPDV(); }}
                                >
                                    <i className="bi bi-display"></i>
                                    {localStorage.getItem('terminalNombre')
                                        ? <>PDV: <strong>{localStorage.getItem('terminalNombre')}</strong></>
                                        : 'Seleccionar punto de venta'
                                    }
                                </button>
                            )}

                            {/* Acciones */}
                            <button
                                className="user-dropdown-item"
                                onClick={() => { setDropdownAbierto(false); setModalPasswordAbierto(true); }}
                            >
                                <i className="bi bi-key"></i>
                                Cambiar contraseña
                            </button>

                            <button className="user-dropdown-item danger" onClick={Salir}>
                                <i className="bi bi-box-arrow-right"></i>
                                Cerrar sesión
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <style>{`
                @keyframes dropdownIn {
                    from { opacity: 0; transform: translateY(-6px) scale(0.97); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                }
            `}</style>

            <ModalCambiarPassword
                abierto={modalPasswordAbierto}
                onCerrar={() => setModalPasswordAbierto(false)}
            />
            <ModalPlanes
                abierto={modalPlanesAbierto}
                onCerrar={() => setModalPlanesAbierto(false)}
                planActual={plan}
            />
        </header>
    );
}

export default Menu;
